import React, { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * 路由切换时将页面滚动条重置到顶部。
 * SPA 内导航不会触发浏览器整页刷新，window 滚动位置会保留，需手动处理。
 */
const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    // 使用 instant 避免 html.scroll-smooth 导致路由切换时出现长距离平滑滚动
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
